import React from 'react';
import { SVGAttributes } from 'react';

export const MedicalVerificationGreyIcon: React.FC<SVGAttributes<never>> = (
  props
) => {
  return (
    <svg
      width="64"
      height="64"
      viewBox="0 0 64 64"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <g id="verified">
        <g id="Group">
          <path
            id="Vector"
            d="M7.40689 49.1068C7.40689 36.8099 1.03711 28.3654 1.03711 22.4401C1.03711 16.5148 4.44333 4.07031 31.702 4.07031C58.9607 4.07031 62.9607 20.8116 62.9607 27.329C62.9624 57.8481 7.40689 70.8845 7.40689 49.1068Z"
            fill="#EFEFEF"
          />
        </g>
        <g id="Group_2">
          <g id="Group_3">
            <path
              id="Vector_2"
              d="M47.8242 11.7637L49.0813 10.5066L51.5955 13.0208L50.3384 14.2778L47.8242 11.7637Z"
              fill="white"
            />
          </g>
          <g id="Group_4">
            <path
              id="Vector_3"
              d="M55.0527 18.9902L56.3098 17.7332L58.824 20.2473L57.5669 21.5044L55.0527 18.9902Z"
              fill="white"
            />
          </g>
          <g id="Group_5">
            <path
              id="Vector_4"
              d="M54.7363 13.0176L57.2505 10.5034L58.5076 11.7605L55.9934 14.2747L54.7363 13.0176Z"
              fill="white"
            />
          </g>
        </g>
        <g id="Group_6">
          <path
            id="Vector_5"
            d="M36.048 46.6667H15.5556C13.6 46.6667 12 45.0667 12 43.1111V15.5556C12 13.6 13.6 12 15.5556 12H36C37.9556 12 39.5556 13.6 39.5556 15.5556L39.6036 43.1058C39.6053 45.0702 38.0124 46.6667 36.048 46.6667Z"
            fill="#F3F3F1"
          />
          <g id="Group 28">
            <rect
              id="Rectangle 30514"
              x="22.6465"
              y="17.6973"
              width="4.98579"
              height="10.983"
              fill="white"
            />
            <rect
              id="Rectangle 30515"
              x="30.6309"
              y="20.6914"
              width="4.98579"
              height="10.983"
              transform="rotate(90 30.6309 20.6914)"
              fill="white"
            />
            <path
              id="Vector_6"
              d="M19.1199 27.0653H21.551V29.4964C21.551 29.8188 21.6791 30.128 21.9071 30.356C22.1351 30.5839 22.4442 30.712 22.7666 30.712H27.629C27.9514 30.712 28.2606 30.5839 28.4885 30.356C28.7165 30.128 28.8446 29.8188 28.8446 29.4964V27.0653H31.2757C31.5981 27.0653 31.9073 26.9372 32.1353 26.7092C32.3632 26.4813 32.4913 26.1721 32.4913 25.8497V20.9873C32.4913 20.6649 32.3632 20.3558 32.1353 20.1278C31.9073 19.8998 31.5981 19.7718 31.2757 19.7718H28.8446V17.3406C28.8446 17.0182 28.7165 16.709 28.4885 16.481C28.2606 16.2531 27.9514 16.125 27.629 16.125H22.7666C22.4442 16.125 22.1351 16.2531 21.9071 16.481C21.6791 16.709 21.551 17.0182 21.551 17.3406V19.7718H19.1199C18.7975 19.7718 18.4883 19.8998 18.2603 20.1278C18.0324 20.3558 17.9043 20.6649 17.9043 20.9873V25.8497C17.9043 26.1721 18.0324 26.4813 18.2603 26.7092C18.4883 26.9372 18.7975 27.0653 19.1199 27.0653ZM20.3355 22.2029H22.7666C23.089 22.2029 23.3982 22.0749 23.6262 21.8469C23.8541 21.6189 23.9822 21.3097 23.9822 20.9873V18.5562H26.4134V20.9873C26.4134 21.3097 26.5415 21.6189 26.7694 21.8469C26.9974 22.0749 27.3066 22.2029 27.629 22.2029H30.0601V24.6341H27.629C27.3066 24.6341 26.9974 24.7622 26.7694 24.9901C26.5415 25.2181 26.4134 25.5273 26.4134 25.8497V28.2808H23.9822V25.8497C23.9822 25.5273 23.8541 25.2181 23.6262 24.9901C23.3982 24.7622 23.089 24.6341 22.7666 24.6341H20.3355V22.2029Z"
              fill="#ABABAB"
            />
          </g>
        </g>
        <g id="Group_7">
          <path
            id="Vector_7"
            d="M16 43.1111V15.5556C16 13.6 17.6 12 19.5556 12H15.5556C13.6 12 12 13.6 12 15.5556V43.1111C12 45.0667 13.6 46.6667 15.5556 46.6667H19.5556C17.6 46.6667 16 45.0667 16 43.1111Z"
            fill="#D5DBE1"
          />
        </g>
        <g id="Group_8">
          <path
            id="Vector_8"
            d="M35.5586 41.7789C35.5586 36.8189 39.0928 32.6855 43.7808 31.7558C43.1337 31.6278 42.4653 31.5566 41.7808 31.5566C36.1346 31.5566 31.5586 36.1326 31.5586 41.7789C31.5586 47.4251 36.1346 52.0011 41.7808 52.0011C42.4653 52.0011 43.1337 51.9318 43.7808 51.802C39.0928 50.8722 35.5586 46.7389 35.5586 41.7789Z"
            fill="#D5DBE1"
          />
        </g>
        <g id="Group_9">
          <path
            id="Vector_9"
            d="M17.7793 34.666H28.446V37.3327H17.7793V34.666Z"
            fill="#ABABAB"
          />
        </g>
        <g id="Group_10">
          <path
            id="Vector_10"
            d="M17.7793 40H26.6682V42.6667H17.7793V40Z"
            fill="#ABABAB"
          />
        </g>
        <g id="Group_11">
          <path
            id="Vector_11"
            d="M26.666 47.9993H15.5549C12.858 47.9993 10.666 45.8073 10.666 43.1105V15.5549C10.666 12.858 12.858 10.666 15.5549 10.666H35.9993C38.6962 10.666 40.8882 12.858 40.8882 15.5549V26.7727H38.2216V15.5549C38.2216 14.33 37.2242 13.3327 35.9993 13.3327H15.5549C14.33 13.3327 13.3327 14.33 13.3327 15.5549V43.1105C13.3327 44.3353 14.33 45.3327 15.5549 45.3327H26.666V47.9993Z"
            fill="#ABABAB"
          />
        </g>
        <g id="Group_12">
          <path
            id="Vector_12"
            d="M41.7763 53.3318C35.4047 53.3318 30.2207 48.1478 30.2207 41.7763C30.2207 35.4047 35.4047 30.2207 41.7763 30.2207C48.1478 30.2207 53.3318 35.4047 53.3318 41.7763C53.3318 48.1478 48.1478 53.3318 41.7763 53.3318ZM41.7763 32.8874C36.8749 32.8874 32.8874 36.8749 32.8874 41.7763C32.8874 46.6776 36.8749 50.6651 41.7763 50.6651C46.6776 50.6651 50.6651 46.6776 50.6651 41.7763C50.6651 36.8749 46.6776 32.8874 41.7763 32.8874Z"
            fill="#ABABAB"
          />
        </g>
        <g id="Group_13">
          <path
            id="Vector_13"
            d="M44.5058 37.6816H41.0928C40.5496 37.6816 40.0288 37.8974 39.6447 38.2814C39.2607 38.6655 39.0449 39.1863 39.0449 39.7295C39.0449 40.2726 39.2607 40.7934 39.6447 41.1775C40.0288 41.5615 40.5496 41.7773 41.0928 41.7773H42.458C43.0011 41.7773 43.522 41.993 43.906 42.3771C44.29 42.7611 44.5058 43.282 44.5058 43.8251C44.5058 44.3682 44.29 44.8891 43.906 45.2732C43.522 45.6572 43.0011 45.8729 42.458 45.8729H39.0449M41.7754 45.8729V47.2382M41.7754 36.3164V37.6816"
            stroke="#ABABAB"
            strokeWidth="2.06452"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </g>
      </g>
    </svg>
  );
};

export default MedicalVerificationGreyIcon;
